<template>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<h1 class="page-header">Grabverwaltung</h1>
			</div>
		</div>

		<graveyard-select></graveyard-select>

		<custom-table edit="/graves/{:id}" add="/graves/new" search :src-model="$store.getters.models('graves')" :cols="cols" :default-sort="defSort"></custom-table>
	</div>
</template>

<script>
import CustomTable from 'components/custom-table.vue'
import GraveyardSelect from 'components/graveyard-select.vue'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
  beforeRouteEnter (to, from, next) {
    const route = authCheck('graves')
    if (route === null) {
      next()
    } else {
      next(route)
    }
  },

	data () {
		return {
			cols: [
				{
					name: 'Name',
					json: 'name',
					type: 'text'
				},
				{
					name: 'Art',
					json: 'type_short_name',
					txpe: 'text'
				},
				{
					name: 'Preis',
					json: 'real_price',
					type (aValue) {
						return aValue < 1 ? null : [aValue + " €"]
					}
				},
				{
					name: 'Beschreibung',
					json: 'description',
					type: 'text',
					colCSS: 'hidden-xs'
				},
				{
					name: 'Fläche',
					json: 'area_name',
					type: 'text'
				},
				{
					name: 'Kunden',
					json: 'customer_count',
					type: 'int',
                    css: {
                        default: 'btn btn-danger',
                        0: 'btn btn-success'
                    }
				},
				{
					name: 'Verstorbene',
					json: 'deceased_count',
					type: 'int',
                    css: {
                        default: 'btn btn-danger',
                        0: 'btn btn-success'
                    }
				}
			],

			defSort: { col: 'id', order: 'asc' }
		}
	},

	components: {
		'graveyard-select': GraveyardSelect,
		'custom-table': CustomTable
	},

	activated () {
		this.$store.dispatch('loadModel', 'graves')
	},

	methods: {
		print (aModels) {
			aModels[0] = aModels[0].map(aValue => {
				return {text: aValue, style: 'tableHeader', alignment: 'center'}
			})

			let dd = {
				footer: function (currentPage, pageCount) {
					return { text: 'Seite ' + currentPage + ' von ' + pageCount, alignment: (currentPage % 2) ? 'left' : 'right' };
				},

				content: [
					{
						table: {
							headerRows: 1,
							widths: ['*', '*', '*', '*'],

							body: aModels
						}
					}
				],
				styles: {
					header: {
						fontSize: 18,
						bold: true,
						margin: [0, 0, 0, 10]
					},
					subheader: {
						fontSize: 16,
						bold: true,
						margin: [0, 10, 0, 5]
					},
					tableExample: {
						margin: [0, 5, 0, 15]
					},
					tableHeader: {
						bold: true,
						fontSize: 13,
						color: 'black'
					}
				}
			}

			pdfMake.createPdf(dd).open()
		}
	}
}
</script>



// WEBPACK FOOTER //
// GraveOverview.vue?b595bc50